<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div class="flex">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-select
        size="small"
        clearable
        filterable
        v-model="search.dataMainTypeId"
        placeholder="请选择类型"
        class="w-200px mr-10px ml-10px"
      >
        <el-option
          v-for="item in mainDataTypeList"
          :key="item.id"
          :label="item.typeName"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        filterable
        v-model="search.classId"
        :placeholder="`${$t('pleaseSelectClass')}`"
        class="w-200px mr-10px"
        :disabled="!classList.length"
        @change="changeClassId"
      >
        <el-option
          v-for="item in classList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        filterable
        v-model="search.attrId"
        :placeholder="`${$t('pleaseSelectAttr')}`"
        class="w-200px mr-10px"
      >
        <el-option
          v-for="item in attrList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        filterable
        v-model="search.symbolValue"
        placeholder="选择搜索条件"
        class="w-200px mr-10px"
      >
        <el-option
          v-for="item in symbolList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        class="w-200px mr-10px"
        v-model.trim="search.keyword"
        :placeholder="`${$t('pleaseEnterKeyWords')}`"
        clearable
      ></el-input>
      <el-button type="primary" @click="searchCodeList">{{ $t('search') }}</el-button>
      <el-button type="primary" @click="addEntity({}, 'add')" :disabled="!$hasAccess('create')">{{
        $t('create')
      }}</el-button>
      <el-button
        type="danger"
        :disabled="!$hasAccess('delete')"
        @click="deleteDynamicData(idsList)"
        >{{ $t('delete') }}</el-button
      >
      <el-button :disabled="!$hasAccess('export')" @click="exportExcel" :loading="exportLoading">{{
        $t('export')
      }}</el-button>
      <el-button :disabled="!$hasAccess('import')" @click="importFile">{{
        $t('import')
      }}</el-button>
    </div>
    <!-- 动态列表格-->
    <el-table
      class="mt-20px"
      ref="table"
      :data="valueList"
      v-loading="listLoading"
      border
      :highlight-current-row="true"
      @sort-change="sortChangeLog"
      height="calc(100% - 106px)"
      @selection-change="handleSelectionChange"
      row-key="id"
    >
      <el-table-column
        v-if="tableHeader.length"
        fixed
        :reserve-selection="true"
        type="selection"
        width="40"
      ></el-table-column>
      <el-table-column
        type="index"
        v-if="tableHeader.length"
        width="60"
        :label="`${$t('seqNo')}`"
        sortable
      ></el-table-column>
      <el-table-column
        v-for="(val, index) in tableHeader"
        :prop="`${val.tableName}.${val.columnName}`"
        sortable="custom"
        show-overflow-tooltip
        :key="index"
        :label="val.name"
        min-width="150"
      >
        <template slot-scope="scope">
          <div class="truncate">
            {{ scope.row[`${val.tableName}.${val.columnName}`] }}
            <span v-if="val.unit && scope.row[`${val.tableName}.${val.columnName}`]">{{
              val.unit
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="`${$t('operate')}`"
        v-if="tableHeader.length"
        width="200"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="addEntity(scope.row, 'read')">{{ $t('view') }}</el-button>
          <el-button
            :disabled="!$hasAccess('update')"
            size="mini"
            @click="addEntity(scope.row, 'edit')"
            >{{ $t('edit') }}</el-button
          >
          <el-button
            :disabled="!$hasAccess('delete')"
            size="mini"
            @click="deleteDynamicData([scope.row])"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <div class="mt-20px float-right pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next"
        :total="recordCount"
      ></el-pagination>
    </div>

    <!-- 新增编辑弹框--新 -->
    <HandoverFormDialog
      v-if="handoverFormProps.dialogVisible"
      :handoverFormProps="handoverFormProps"
      @handoverFormEmit="handoverFormEmit"
    />

    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchCodeList"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import fnMixin from '@/assets/js/fnMixins'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import assetService from '@/services/assetService'
import documentManagementService from '@/services/documentManagement'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import MasterDataManageService from '@/services/masterDataManageService'
import selectStandardId from '../../components/selectStandardId'
import HandoverFormDialog from '../../components/handoverFormDialog'

export default {
  name: 'MasterDataManagement',
  components: {
    selectStandardId,
    HandoverFormDialog,
  },
  mixins: [fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      handoverFormProps: {
        classId: '',
        dialogVisible: false, // form弹框显示状态
        standardId: localStorage.getItem('standardId'),
        tabs: [],
        rowData: null,
        isShowClassType: false, // 是否显示实体类型
        isDataDetail: true, // 是否实体数据管理
      },
      mainDataTypeList: [],
      classList: [],
      attrList: [],
      symbolList: [],
      search: {
        standardId: localStorage.getItem('standardId'),
        dataMainTypeId: '',
        classId: '',
        attrId: '',
        symbolValue: '',
        keyword: '',
      },
      stdClassName: '', // 实体名称
      exportLoading: false,
      listLoading: false,
      currentSortParams: {
        orderby: '',
        orderbytype: '',
      }, // 排序查询条件
      valueList: [],
      recordCount: 0,
      pageNo: 1,
      pageSize: 15,
      tableHeader: [],
      idsList: [],
    }
  },
  watch: {
    // 标准库id
    'search.standardId': {
      handler(newVal) {
        if (newVal) {
          this.search.classId = ''
          this.getClassList()
        }
      },
    },
    // 主数据类型id
    'search.dataMainTypeId': {
      handler() {
        this.search.classId = ''
        this.getClassList()
      },
    },
    // 实体id
    'search.classId': {
      handler(val) {
        this.search.attrId = ''
        this.attrList = []
        // this.symbolValue = ''
        this.search.keyword = ''
        if (val) {
          this.getAttrList()
          this.getDynamicTableHeader()
          this.searchCodeList()
        }
      },
    },
  },
  methods: {
    updateStandardId(val) {
      this.search.standardId = val
      this.handoverFormProps.standardId = val
    },
    // 获取主数据类型
    async getMainDataType() {
      const parameter = {
        SkipCount: 1,
        MaxResultCount: 999,
        Sorting: '',
      }
      const res = await MasterDataManageService.getList(parameter)
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.mainDataTypeList = res.data
      } else {
        this.mainDataTypeList = []
      }
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        data_type: 1,
        standard_id: this.search.standardId,
        approve_status: 1, // 已发布
        is_type: false, // 是否为类型
        data_main_type_id: this.search.dataMainTypeId, // 主数据类型
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
        if (this.classList.length) {
          this.search.classId = this.classList[0].id
          this.getClassTypeNameById(this.search.classId, this.classList[0].name)
          this.stdClassName = this.classList[0].name
        }
      }
    },
    // 获取属性列表
    async getAttrList() {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId: this.search.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        this.attrList = res.data
        if (this.attrList.length) {
          this.search.attrId = this.attrList[0].id
        }
      }
    },
    // 获取操作符
    async getSymbolList() {
      this.symbolList = []
      const res = await assetService.getSearchOperator()
      if (res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          this.symbolList.push({
            label: item.text,
            value: item.value,
          })
        })
        if (this.symbolList.length) {
          this.search.symbolValue = this.symbolList[0].value
        }
      }
    },
    // 根据id获取实体类型名称
    async getClassTypeNameById(id, name) {
      const res = await documentManagementService.getClassTypeNameById({
        id,
      })
      if (res && res.code === 0) {
        this.handoverFormProps.classId = id
        if (res.data && _.includes(['对象', '文档'], res.data)) {
          this.handoverFormProps.tabs = [
            { name: res.data === '对象' ? '位号' : '文档', label: '1' },
            { name, label: '2' },
          ]
        } else if (res.data && !_.includes(['对象', '文档'], res.data)) {
          this.handoverFormProps.tabs = [
            { name: res.data, label: '1' },
            { name, label: '2' },
          ]
        } else if (!res.data) {
          this.handoverFormProps.tabs = [{ name, label: '2' }]
        }
      }
    },
    // 修改实体id
    changeClassId(val) {
      const className = _.find(this.classList, { id: val })
      if (className) this.stdClassName = className.name
      this.getClassTypeNameById(val, this.stdClassName)
    },
    // 获取实体数据管理动态表头
    async getDynamicTableHeader() {
      const res = await stdClassDataService.getDynamicTableHeader({ classId: this.search.classId })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      }
    },
    // 获取编码列表
    async searchCodeList() {
      if (!this.search.classId) {
        this.$message({
          message: this.$t('pleaseSelectClass'),
          type: 'warning',
        })
        return
      }
      this.listLoading = true
      const parameter = {
        classId: this.search.classId,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        // isAddTagOrDocument: true, // 带上位号或文档的值
        whereList: [],
        classAttributeId: this.search.attrId,
        operator: this.search.symbolValue,
        keywords: this.search.keyword,
        Sorting: `${this.currentSortParams.orderby} ${this.currentSortParams.orderbytype}`,
      }
      const res = await stdClassDataService.getDynamicTableData(parameter)
      this.listLoading = false
      if (res && res.code === 0 && res.data) {
        this.valueList = _.cloneDeep(res.data)
        this.recordCount = res.totalCount
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.doLayout()
          }
        })
      } else {
        this.valueList = []
        this.recordCount = 0
      }
    },
    // 打开新增编码弹窗
    async addEntity(row, type) {
      if (!this.search.classId) {
        this.$message.warning('请选择实体！')
        return
      }
      this.handoverFormProps.rowData = row
      this.handoverFormProps.rowData.classId = this.search.classId
      this.handoverFormProps.dialogVisible = true
      if (type) {
        this.handoverFormProps.type = type
      }
    },
    // 文件导出
    exportExcel() {
      this.$confirm('可能需要等待时间较长，请确认是否要继续', `${this.$t('hint')}?`, {
        confirmButtonText: `${this.$t('Sure')}`,
        cancelButtonText: `${this.$t('Cancel')}`,
        type: 'warning',
      }).then(() => {
        this.exportDynamicTableData()
      })
    },
    // 动态表格导出数据
    async exportDynamicTableData() {
      this.exportLoading = true
      const res = await documentManagementService.exportDynamicTableData({
        standardId: this.search.standardId,
        cateCode: '',
        classIds: [this.search.classId],
        ids: this.idsList,
      })
      this.exportLoading = false
      if (res) {
        this.downLoadExcel(`${this.stdClassName}-数据明细导出结果.xlsx`, res)
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await documentManagementService.downloadTemplate({
        standardId: this.search.standardId,
        cateCode: '',
        classIds: [this.search.classId],
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: `${this.stdClassName}-数据明细导入模板.xlsx`,
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.search.standardId)
      formData.append('cateCode', '')
      formData.append('classId', this.search.classId)
      const res = await documentManagementService.importDynamicTableData(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: `${this.stdClassName}-数据明细导入明细.xlsx`,
          data: res,
        })
        this.searchCodeList()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 新增弹框子组件传参
    handoverFormEmit(val) {
      if (val) {
        this.handoverFormProps.dialogVisible = val.dialogVisible
        this.searchCodeList()
      }
    },
    sortChangeLog(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 'asc'
          break
        case 'descending':
          orderbytype = 'desc'
          break
        default:
          orderbytype = ''
          break
      }
      this.currentSortParams = {
        orderby: row.prop,
        orderbytype,
      }
      this.searchCodeList()
    },
    handleSelectionChange(val) {
      this.idsList = _.map(val, (item) => {
        return item.id
      })
    },
    // 删除动态数据
    deleteDynamicData(rows) {
      if (rows.length > 0) {
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const params = []
          _.map(rows, (item) => {
            params.push({
              type: 0,
              standardId: this.search.standardId,
              dataId: item,
              classId: this.search.classId,
            })
          })
          const res = await documentManagementService.deleteDynamicData(params)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchCodeList()
          }
        })
      } else {
        this.$message.warning('请选择要删除的数据')
      }
    },
    // 改变页数
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchCodeList()
    },
    // 改变每页条数
    handleSizeChange(size) {
      this.pageSize = size
      this.searchCodeList()
    },
  },
  created() {
    this.getMainDataType()
    this.getClassList()
    this.getSymbolList()
  },
}
</script>
